import Fuse from 'fuse.js';

export default {
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      } else {
        if (this.searchQuery) {
          result = [];
        }
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
    },
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: '',
      searchedData: [],
      searchKeys: [],
      fuseSearch: null,
    };
  },
  methods: {
    sortChange({ prop, order }) {
      if (prop) {
        this.tableData.sort((a, b) => {
          let aVal = a[prop];
          let bVal = b[prop];
          if (typeof aVal === 'string') {
            if (order === 'ascending') {
              return aVal > bVal ? 1 : -1;
            }
            return bVal > aVal ? 1 : -1;
          }
          if (order === 'ascending') {
            return aVal > bVal ? 1 : -1;
          }
          return bVal - aVal;
        });
      } else {
        this.tableData.sort((a, b) => {
          return a.id - b.id;
        });
      }
    },
  },
  mounted() {},
  watch: {
    tableData(value) {
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.searchKeys,
        threshold: 0.3,
        distance: 1000,
      });
    },
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(value);
      }
      this.searchedData = result;
    },
  },
};
